/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyDto } from './CompanyDto';
import {
    CompanyDtoFromJSON,
    CompanyDtoFromJSONTyped,
    CompanyDtoToJSON,
} from './CompanyDto';

/**
 * 
 * @export
 * @interface MergeCompanyResponse
 */
export interface MergeCompanyResponse {
    /**
     * 
     * @type {CompanyDto}
     * @memberof MergeCompanyResponse
     */
    targetCompany: CompanyDto;
}

/**
 * Check if a given object implements the MergeCompanyResponse interface.
 */
export function instanceOfMergeCompanyResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "targetCompany" in value;

    return isInstance;
}

export function MergeCompanyResponseFromJSON(json: any): MergeCompanyResponse {
    return MergeCompanyResponseFromJSONTyped(json, false);
}

export function MergeCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeCompanyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetCompany': CompanyDtoFromJSON(json['target_company']),
    };
}

export function MergeCompanyResponseToJSON(value?: MergeCompanyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_company': CompanyDtoToJSON(value.targetCompany),
    };
}

